import { z } from 'zod';

export const boostPostSchema = z
  .object({
    adAccount: z.object({
      id: z.string().min(1, { message: 'Please select an ad account.' }),
    }),
    post: z.object({
      postExternalId: z.string().min(1, { message: 'Please select a post.' }),
      platform: z.literal('instagram'),
    }),
    campaign: z.discriminatedUnion('type', [
      z.object({
        type: z.literal('existing'),
        campaignId: z.string().min(1, { message: 'Please select a campaign.' }),
      }),
      z.object({
        type: z.literal('new'),
        name: z.string().min(2, { message: 'Campaign name must be at least 2 characters.' }),
        objective: z.enum([
          'OUTCOME_APP_PROMOTION',
          'OUTCOME_AWARENESS',
          'OUTCOME_ENGAGEMENT',
          'OUTCOME_LEADS',
          'OUTCOME_SALES',
          'OUTCOME_TRAFFIC',
        ]),
      }),
    ]),
    adSet: z
      .discriminatedUnion('type', [
        z.object({
          type: z.literal('existing'),
          id: z.string().min(1, { message: 'Please select an ad set.' }),
        }),
        z.object({
          type: z.literal('new'),
          name: z.string().min(2, { message: 'Ad set name must be at least 2 characters.' }),
        }),
      ])
      .optional(),
    // ...other fields for boost post can go here
  })
  .superRefine((val, ctx) => {
    if (val.adSet?.type === 'existing' && val.campaign.type !== 'existing') {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'You can only select an existing Ad Set if you have selected an existing Campaign.',
        path: ['adSet', 'type'],
      });
    }
  });

export type BoostPostFormValues = z.infer<typeof boostPostSchema>;
